// extracted by mini-css-extract-plugin
export var actionsRow = "_s-a";
export var actionsRowEnd = "_s-b";
export var askRedoBlackBtn = "_s-d";
export var askRedoBlackBtnIcon = "_s-e";
export var exitModalActionBtn = "_s-c";
export var exitModalRoot = "_s-0";
export var followUpInput = "_s-9";
export var modalContentBody = "_s-7";
export var modalHeaderImage = "_s-2";
export var modalImageLabel = "_s-4";
export var modalImageOverlay = "_s-3";
export var modalImageSubheading = "_s-6";
export var modalImageTitle = "_s-5";
export var modalImageWrapper = "_s-1";
export var reasonCard = "_s-f";
export var reasonCardSelected = "_s-g";
export var reasonIcon = "_s-j";
export var reasonIconWrap = "_s-i";
export var reasonIndicator = "_s-l";
export var reasonIndicatorDot = "_s-n";
export var reasonIndicatorSelected = "_s-m";
export var reasonLabel = "_s-h";
export var reasonList = "_s-8";
export var reasonTitle = "_s-k";